export enum NotifyMode {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}
